var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3994.5853598405306 2263.5983705763006",
    width: 3994.5853598405306,
    height: 2263.5983705763006,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }, "\n      @font-face {\n        font-family: \"Virgil\";\n        src: url(\"https://excalidraw.com/Virgil.woff2\");\n      }\n      @font-face {\n        font-family: \"Cascadia\";\n        src: url(\"https://excalidraw.com/Cascadia.woff2\");\n      }\n      @font-face {\n        font-family: \"Assistant\";\n        src: url(\"https://excalidraw.com/Assistant-Regular.woff2\");\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "QiyQeUd1Rd70uVlKvTYhm"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 0) rotate(0 1997.2926799202653 1131.7991852881503)",
    width: 3994.5853598405306,
    height: 2263.5983705763006
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3994.5853598405306,
    height: 2263.5983705763006,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3247.1108419122347 260.78245149409594) rotate(0 0 978.4088317117177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 326.14, 0 1630.68, 0 1956.82",
    stroke: "#343a40",
    strokeWidth: 4.5,
    fill: "none",
    strokeDasharray: "1.5 10"
  }))), /*#__PURE__*/React.createElement("mask", null))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.57750145813316 206.28245149409594) rotate(0 110.35832977294922 22.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "36px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Main Thread"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2397.2753773894233 206.28245149409594) rotate(0 173.94166564941406 22.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "36px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Projectiles Compute"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3010.577501458133 213.40745149409594) rotate(0 236.53334045410156 22.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "36px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Bionic Merge Sort Compute"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.57750145813316 284.40745149409594) rotate(0 102.03333282470703 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Set Member's Buffer"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.57750145813316 350.90745149409594) rotate(0 111.2249984741211 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Set Projectiles Buffer"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.57750145813316 389.40745149409594) rotate(0 111.28333282470703 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Sets an empty array of the"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "maximum projectile size."))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2570.2170430388373 260.78245149409594) rotate(0 0 979.6193121237906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 326.54, 0 1632.7, 0 1959.24",
    stroke: "#343a40",
    strokeWidth: 4.5,
    fill: "none",
    strokeDasharray: "1.5 10"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.9358312310824 260.78245149409594) rotate(0 0 982.0402729479364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 327.35, 0 1636.73, 0 1964.08",
    stroke: "#343a40",
    strokeWidth: 4.5,
    fill: "none",
    strokeDasharray: "1.5 10"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-wHEP2m8S5wu_QvQMG6Iei)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3251.1412753925933 859.5802948588419) rotate(0 45.5 65.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.17 11.67, 89.62 48.08, 91 70 C92.38 91.92, 22.05 121.25, 8.26 131.5 M0 0 C15.17 11.67, 89.62 48.08, 91 70 C92.38 91.92, 22.05 121.25, 8.26 131.5",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3251.1412753925933 859.5802948588419) rotate(0 45.5 65.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26 131.5 L16.99 119.3 L23.22 130.34 L8.26 131.5",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26 131.5 C11.3 127.25, 14.34 123, 16.99 119.3 M8.26 131.5 C10.15 128.86, 12.04 126.22, 16.99 119.3 M16.99 119.3 C19.32 123.43, 21.66 127.57, 23.22 130.34 M16.99 119.3 C18.81 122.52, 20.63 125.75, 23.22 130.34 M23.22 130.34 C19.36 130.64, 15.5 130.94, 8.26 131.5 M23.22 130.34 C20.21 130.57, 17.2 130.81, 8.26 131.5 M8.26 131.5 C8.26 131.5, 8.26 131.5, 8.26 131.5 M8.26 131.5 C8.26 131.5, 8.26 131.5, 8.26 131.5",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-wHEP2m8S5wu_QvQMG6Iei"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 3442.1412753925933,
    height: 1091.0802948588419
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3263.974611269058,
    y: 917.0802948588419,
    fill: "#000",
    width: 156.3333282470703,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3263.974611269058 917.0802948588419) rotate(0 32.6766457102554 8.25)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 78.16666412353516,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Sort Projectiles"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3443.466390347022 900.0802948588419) rotate(0 171.28334045410156 30)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Sorts the data so that valid/active"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "projectiles are at the start of the buffer"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "nulls are left at the end."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3258.577501458133 999.0802948588419) rotate(0 102.11666870117188 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Store the last index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3481.466390347022 1016.0802948588419) rotate(0 240.48333740234375 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Keep track of when the last valid data exists in the array."), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "This is how we'll know where to store new valid projectiles"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1360.219171685184 206.28245149409594) rotate(0 58.400001525878906 22.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "36px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Buffer"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1418.6191732110628 260.78245149409594) rotate(0 0 979.6193121237906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 326.54, 0 1632.7, 0 1959.24",
    stroke: "#343a40",
    strokeWidth: 4.5,
    fill: "none",
    strokeDasharray: "1.5 10"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8AM04HqhVpfuXE4FTusGw)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.5775014581332 294.40745149409594) rotate(0 434 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C144.67 0, 723.33 0, 868 0 M0 0 C144.67 0, 723.33 0, 868 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.5775014581332 294.40745149409594) rotate(0 434 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868 0 L854.41 6.34 L854.41 -6.34 L868 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 0 C863.63 2.04, 859.25 4.08, 854.41 6.34 M868 0 C863.49 2.1, 858.98 4.2, 854.41 6.34 M854.41 6.34 C854.41 2.44, 854.41 -1.46, 854.41 -6.34 M854.41 6.34 C854.41 1.37, 854.41 -3.6, 854.41 -6.34 M854.41 -6.34 C858.89 -4.25, 863.37 -2.16, 868 0 M854.41 -6.34 C859.76 -3.84, 865.11 -1.35, 868 0 M868 0 C868 0, 868 0, 868 0 M868 0 C868 0, 868 0, 868 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8AM04HqhVpfuXE4FTusGw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 1517.5775014581332,
    height: 394.40745149409594
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.9024984063753,
    y: 281.90745149409594,
    fill: "#000",
    width: 201.35000610351562,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(882.9024984063753 281.90745149409594) rotate(0 100.67500305175781 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 100.67500305175781,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Squad Member Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(845.5775014581332 319.40745149409594) rotate(0 118.17500305175781 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Struct: Matrix, Velocity, etc..."))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-H59WXNu3x0U4Qfsv4XnVQ)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.5775014581332 361.40745149409594) rotate(0 435.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C145.17 0, 725.83 0, 871 0 M0 0 C145.17 0, 725.83 0, 871 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.5775014581332 361.40745149409594) rotate(0 435.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871 0 L857.41 6.34 L857.41 -6.34 L871 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871 0 C866.12 2.28, 861.24 4.55, 857.41 6.34 M871 0 C866.63 2.04, 862.25 4.08, 857.41 6.34 M857.41 6.34 C857.41 1.5, 857.41 -3.33, 857.41 -6.34 M857.41 6.34 C857.41 2.97, 857.41 -0.39, 857.41 -6.34 M857.41 -6.34 C860.51 -4.89, 863.62 -3.44, 871 0 M857.41 -6.34 C861.87 -4.26, 866.34 -2.17, 871 0 M871 0 C871 0, 871 0, 871 0 M871 0 C871 0, 871 0, 871 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-H59WXNu3x0U4Qfsv4XnVQ"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 1519.5775014581332,
    height: 461.40745149409594
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.1358358087191,
    y: 348.90745149409594,
    fill: "#000",
    width: 155.88333129882812,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(906.1358358087191 348.90745149409594) rotate(0 77.94166564941406 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 77.94166564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Projectile Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(845.2358342828402 382.40745149409594) rotate(0 142.10000610351562 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Struct: Matrix, Velocity, Valid, etc..."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.8934200582744 841.5802948588419) rotate(0 120.36666870117188 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Dispatch Projectile Sort"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.1412753925933 851.5802948588419) rotate(0 1348 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C449.33 0, 2246.67 0, 2696 0 M0 0 C449.33 0, 2246.67 0, 2696 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.1412753925933 851.5802948588419) rotate(0 1348 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2696 0 L2682.41 6.34 L2682.41 -6.34 L2696 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2696 0 C2691.12 2.27, 2686.25 4.55, 2682.41 6.34 M2696 0 C2692.56 1.61, 2689.11 3.21, 2682.41 6.34 M2682.41 6.34 C2682.41 3.53, 2682.41 0.72, 2682.41 -6.34 M2682.41 6.34 C2682.41 2.77, 2682.41 -0.79, 2682.41 -6.34 M2682.41 -6.34 C2686.72 -4.33, 2691.03 -2.32, 2696 0 M2682.41 -6.34 C2687.04 -4.18, 2691.67 -2.02, 2696 0 M2696 0 C2696 0, 2696 0, 2696 0 M2696 0 C2696 0, 2696 0, 2696 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-VLRPX1kwfe4KNCoK7xclW)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3251.577501458133 1009.5802948588419) rotate(0 -914.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-73.33 0, -135.17 0, -440 0 C-744.83 0, -1597.5 0, -1829 0 M0 0 C-73.33 0, -135.17 0, -440 0 C-744.83 0, -1597.5 0, -1829 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3251.577501458133 1009.5802948588419) rotate(0 -914.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1829 0 L-1815.41 -6.34 L-1815.41 6.34 L-1829 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1829 0 C-1825.3 -1.73, -1821.59 -3.45, -1815.41 -6.34 M-1829 0 C-1823.62 -2.51, -1818.24 -5.02, -1815.41 -6.34 M-1815.41 -6.34 C-1815.41 -1.54, -1815.41 3.25, -1815.41 6.34 M-1815.41 -6.34 C-1815.41 -2.51, -1815.41 1.32, -1815.41 6.34 M-1815.41 6.34 C-1820.37 4.03, -1825.33 1.71, -1829 0 M-1815.41 6.34 C-1818.85 4.73, -1822.3 3.13, -1829 0 M-1829 0 C-1829 0, -1829 0, -1829 0 M-1829 0 C-1829 0, -1829 0, -1829 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-VLRPX1kwfe4KNCoK7xclW"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 5180.577501458133,
    height: 1109.5802948588419
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2704.785837334598,
    y: 997.0802948588419,
    fill: "#000",
    width: 213.5833282470703,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2704.785837334598 997.0802948588419) rotate(0 -367.70833587646484 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 106.79166412353516,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Last Projectile Index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2772.577501458133 1025.0802948588419) rotate(0 95.20833587646484 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "uint: lastProjectileIndex"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.5775014581332 47.40745149409594) rotate(0 139.72500610351562 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Where our Update call is happening!"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.5775014581332 66.40745149409594) rotate(0 -28.5 65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-9.5 3.67, -47.83 0.33, -57 22 C-66.17 43.67, -55.33 112, -55 130 M0 0 C-9.5 3.67, -47.83 0.33, -57 22 C-66.17 43.67, -55.33 112, -55 130",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.5775014581332 66.40745149409594) rotate(0 -28.5 65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-55 130 L-62.47 116.99 L-49.84 115.92 L-55 130",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 130 C-57.38 125.86, -59.76 121.71, -62.47 116.99 M-55 130 C-56.69 127.05, -58.39 124.1, -62.47 116.99 M-62.47 116.99 C-59.4 116.73, -56.32 116.47, -49.84 115.92 M-62.47 116.99 C-58.17 116.63, -53.87 116.26, -49.84 115.92 M-49.84 115.92 C-51.12 119.43, -52.41 122.94, -55 130 M-49.84 115.92 C-51.12 119.42, -52.41 122.92, -55 130 M-55 130 C-55 130, -55 130, -55 130 M-55 130 C-55 130, -55 130, -55 130",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.91083479146346 518.9645855705869) rotate(0 99.2249984741211 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Dispatch Projectiles"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.1330570136829 538.1312522372536) rotate(0 1010.0795476323681 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C336.69 0, 1683.47 0, 2020.16 0 M0 0 C336.69 0, 1683.47 0, 2020.16 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.1330570136829 538.1312522372536) rotate(0 1010.0795476323681 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2020.16 0 L2006.56 6.34 L2006.56 -6.34 L2020.16 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020.16 0 C2016.35 1.78, 2012.54 3.55, 2006.56 6.34 M2020.16 0 C2015.92 1.98, 2011.69 3.95, 2006.56 6.34 M2006.56 6.34 C2006.56 2.49, 2006.56 -1.36, 2006.56 -6.34 M2006.56 6.34 C2006.56 2.14, 2006.56 -2.05, 2006.56 -6.34 M2006.56 -6.34 C2011.17 -4.19, 2015.78 -2.04, 2020.16 0 M2006.56 -6.34 C2010.53 -4.49, 2014.5 -2.64, 2020.16 0 M2020.16 0 C2020.16 0, 2020.16 0, 2020.16 0 M2020.16 0 C2020.16 0, 2020.16 0, 2020.16 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-sdxk_vw3Udb8wGxBTa_zF)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2570.7198218338644 537.5756966816987) rotate(0 49.815880159467895 68.59270125652404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.61 9.59, 99.63 34.66, 99.63 57.52 C99.63 80.39, 16.61 123.91, 0 137.19 M0 0 C16.61 9.59, 99.63 34.66, 99.63 57.52 C99.63 80.39, 16.61 123.91, 0 137.19",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2570.7198218338644 537.5756966816987) rotate(0 49.815880159467895 68.59270125652404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 137.19 L7.95 124.46 L14.85 135.09 L0 137.19",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 137.19 C3.1 132.22, 6.21 127.25, 7.95 124.46 M0 137.19 C1.76 134.37, 3.52 131.56, 7.95 124.46 M7.95 124.46 C10.22 127.96, 12.49 131.45, 14.85 135.09 M7.95 124.46 C10.08 127.75, 12.22 131.04, 14.85 135.09 M14.85 135.09 C11.3 135.59, 7.75 136.09, 0 137.19 M14.85 135.09 C11.59 135.55, 8.33 136.01, 0 137.19 M0 137.19 C0 137.19, 0 137.19, 0 137.19 M0 137.19 C0 137.19, 0 137.19, 0 137.19",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-sdxk_vw3Udb8wGxBTa_zF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 2770.3515821528003,
    height: 774.7610991947467
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2583.126583678679,
    y: 582.5981203216725,
    fill: "#000",
    width: 174.4499969482422,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2583.126583678679 582.5981203216725) rotate(0 37.4091183146532 23.57027761655013)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 87.2249984741211,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Handle Projectiles"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2726.275377389418 624.520141126143) rotate(0 187.51666259765625 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "This is where we update the projectiles matrix,"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "velocity and determine if its valid data"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.00967172465926 495.1530338651596) rotate(0 1639.9999999999995 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C546.67 0, 2733.33 0, 3280 0 M0 0 C546.67 0, 2733.33 0, 3280 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-sbTHTV0Soa7FrRZwqQ6Tm)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1419.2441681247844 1967.059809276289) rotate(0 -435 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-145 0, -725 0, -870 0 M0 0 C-145 0, -725 0, -870 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1419.2441681247844 1967.059809276289) rotate(0 -435 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-870 0 L-856.41 -6.34 L-856.41 6.34 L-870 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-870 0 C-866.05 -1.84, -862.1 -3.69, -856.41 -6.34 M-870 0 C-864.72 -2.46, -859.43 -4.93, -856.41 -6.34 M-856.41 -6.34 C-856.41 -2.98, -856.41 0.38, -856.41 6.34 M-856.41 -6.34 C-856.41 -1.3, -856.41 3.75, -856.41 6.34 M-856.41 6.34 C-860.09 4.62, -863.78 2.9, -870 0 M-856.41 6.34 C-859.21 5.03, -862.01 3.72, -870 0 M-870 0 C-870 0, -870 0, -870 0 M-870 0 C-870 0, -870 0, -870 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-sbTHTV0Soa7FrRZwqQ6Tm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 2389.2441681247847,
    height: 2067.059809276289
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.610833011259,
    y: 1954.559809276289,
    fill: "#000",
    width: 111.26667022705078,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(928.610833011259 1954.5598092762891) rotate(0 55.63333511352539 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 55.63333511352539,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Last Index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1428.1330570136724 1953.7264759429554) rotate(0 79.64167022705078 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Get Last Index"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-fTWOeCwa6z0UbukgXcDr6)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.1330570136715 1964.8375870540667) rotate(0 -52.22222222222217 67.22222222222217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-17.41 12.22, -104.44 50.93, -104.44 73.33 C-104.44 95.74, -17.41 124.26, 0 134.44 M0 0 C-17.41 12.22, -104.44 50.93, -104.44 73.33 C-104.44 95.74, -17.41 124.26, 0 134.44",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.1330570136715 1964.8375870540667) rotate(0 -52.22222222222217 67.22222222222217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 134.44 L-15 134.71 L-9.84 123.13 L0 134.44",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 134.44 C-4.73 134.53, -9.46 134.61, -15 134.71 M0 134.44 C-5.33 134.54, -10.66 134.63, -15 134.71 M-15 134.71 C-13.44 131.2, -11.87 127.69, -9.84 123.13 M-15 134.71 C-12.95 130.1, -10.9 125.5, -9.84 123.13 M-9.84 123.13 C-6.99 126.41, -4.14 129.69, 0 134.44 M-9.84 123.13 C-7.25 126.1, -4.67 129.08, 0 134.44 M0 134.44 C0 134.44, 0 134.44, 0 134.44 M0 134.44 C0 134.44, 0 134.44, 0 134.44",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-fTWOeCwa6z0UbukgXcDr6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 752.5775014581159,
    height: 2199.282031498511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.1219469198131,
    y: 2013.1709203874002,
    fill: "#000",
    width: 157.13333129882812,
    height: 50,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.1219469198131 2013.1709203873997) rotate(0 130.78888787163623 18.888888888888914)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 78.56666564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Draw Instanced"), /*#__PURE__*/React.createElement("text", {
    x: 78.56666564941406,
    y: 25,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Mesh"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.46639034700274 2062.8931426096224) rotate(0 135.56666564941406 40)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "This is a Unity handled system,"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "this occures on the GPU not the "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "main thread but we dispatch it "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 60,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "on the main thread."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.7997236803337 2000.393142609622) rotate(0 223.73333740234375 60)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "For the amount of mesh's to draw we use"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "the last index to know how many meshs we will draw,"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "when getting the last index, we might want to throw"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 60,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "a warning telling us if the last index is at our maximum,"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 80,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "this means that we are trying to spawn more projectiles"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 100,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "than we have."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.859965149395975 241.29982924808402) rotate(0 90.41666412353516 17.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "28px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Start Invoke"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.701632324688944 477.6530338651596) rotate(0 87.57499694824219 17.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "28px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Update Loop"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.00967172465926 258.79982924808405) rotate(0 1639.9999999999995 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C546.67 0, 2733.33 0, 3280 0 M0 0 C546.67 0, 2733.33 0, 3280 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1851.3100184015311 209.78908688845485) rotate(0 152.61666870117188 22.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "36px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Members Compute"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2003.926687102703 264.28908688845485) rotate(0 0 976.6555140145382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 325.55, 0 1627.76, 0 1953.31",
    stroke: "#343a40",
    strokeWidth: 4.5,
    fill: "none",
    strokeDasharray: "1.5 10"
  }))), /*#__PURE__*/React.createElement("mask", null))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.91724652709763 1346.4591120898297) rotate(0 109.03333282470703 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Dispatch Spatial Sort"))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.4918467748148 1356.9098018164009) rotate(0 1348.9670236083093 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C449.66 0, 2248.28 0, 2697.93 0 M0 0 C449.66 0, 2248.28 0, 2697.93 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.4918467748148 1356.9098018164009) rotate(0 1348.9670236083093 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2697.93 0 L2684.34 6.34 L2684.34 -6.34 L2697.93 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2697.93 0 C2693.84 1.91, 2689.74 3.82, 2684.34 6.34 M2697.93 0 C2694.92 1.4, 2691.91 2.81, 2684.34 6.34 M2684.34 6.34 C2684.34 3.16, 2684.34 -0.01, 2684.34 -6.34 M2684.34 6.34 C2684.34 2.41, 2684.34 -1.53, 2684.34 -6.34 M2684.34 -6.34 C2688.92 -4.2, 2693.5 -2.07, 2697.93 0 M2684.34 -6.34 C2688.69 -4.31, 2693.05 -2.28, 2697.93 0 M2697.93 0 C2697.93 0, 2697.93 0, 2697.93 0 M2697.93 0 C2697.93 0, 2697.93 0, 2697.93 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-GhI7FqEX_laaHK_u6nRa0)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3246.751008945861 1355.5846868619724) rotate(0 43.72879349614368 60.955287903715316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.58 11.04, 87.46 45.94, 87.46 66.26 C87.46 86.57, 14.58 112.63, 0 121.91 M0 0 C14.58 11.04, 87.46 45.94, 87.46 66.26 C87.46 86.57, 14.58 112.63, 0 121.91",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3246.751008945861 1355.5846868619724) rotate(0 43.72879349614368 60.955287903715316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 121.91 L9.47 110.28 L15 121.69 L0 121.91",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 121.91 C2.76 118.52, 5.52 115.13, 9.47 110.28 M0 121.91 C2.27 119.12, 4.54 116.33, 9.47 110.28 M9.47 110.28 C10.93 113.29, 12.39 116.3, 15 121.69 M9.47 110.28 C11.03 113.5, 12.59 116.73, 15 121.69 M15 121.69 C9.38 121.77, 3.76 121.85, 0 121.91 M15 121.69 C9.44 121.77, 3.88 121.85, 0 121.91 M0 121.91 C0 121.91, 0 121.91, 0 121.91 M0 121.91 C0 121.91, 0 121.91, 0 121.91",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-GhI7FqEX_laaHK_u6nRa0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 3434.2085959381484,
    height: 1577.495262669403
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3267.8919302887343,
    y: 1396.840434583402,
    fill: "#000",
    width: 132.63333129882812,
    height: 50,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3267.8919302887343 1396.840434583402) rotate(0 22.587872153270382 19.699540182285773)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 66.31666564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Sort Members"), /*#__PURE__*/React.createElement("text", {
    x: 66.31666564941406,
    y: 25,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "into cells"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-v_MD52A_klkowuW_XwSZD)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3246.751008945859 1492.0715271681174) rotate(0 -914.3293185557302 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-54.33 0, -21.2 0, -325.98 0 C-630.75 0, -1578.21 0, -1828.66 0 M0 0 C-54.33 0, -21.2 0, -325.98 0 C-630.75 0, -1578.21 0, -1828.66 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3246.751008945859 1492.0715271681174) rotate(0 -914.3293185557302 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1828.66 0 L-1815.06 -6.34 L-1815.06 6.34 L-1828.66 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1828.66 0 C-1824.19 -2.08, -1819.72 -4.17, -1815.06 -6.34 M-1828.66 0 C-1825.56 -1.45, -1822.45 -2.89, -1815.06 -6.34 M-1815.06 -6.34 C-1815.06 -1.95, -1815.06 2.44, -1815.06 6.34 M-1815.06 -6.34 C-1815.06 -2.83, -1815.06 0.69, -1815.06 6.34 M-1815.06 6.34 C-1820.18 3.95, -1825.3 1.57, -1828.66 0 M-1815.06 6.34 C-1819.49 4.28, -1823.91 2.22, -1828.66 0 M-1828.66 0 C-1828.66 0, -1828.66 0, -1828.66 0 M-1828.66 0 C-1828.66 0, -1828.66 0, -1828.66 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-v_MD52A_klkowuW_XwSZD"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 5175.40964605732,
    height: 1592.0715271681174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2854.1644003834763,
    y: 1479.5715271681174,
    fill: "#000",
    width: 133.21665954589844,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2854.164400383476 1479.5715271681174) rotate(0 -521.7427099933468 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 66.60832977294922,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Spatial Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3257.351928581287 1478.8203776238315) rotate(0 98.6500015258789 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Store Spatial Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2859.81744225271 1514.4482514845463) rotate(0 118.08333587646484 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Spatial Offset, Spatial Index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.39489047895313 1549.6635702101553) rotate(0 87.375 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Dispatch Members"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.1420766836723 1562.7644898455842) rotate(0 727.4881099812983 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C242.5 0, 1212.48 0, 1454.98 0 M0 0 C242.5 0, 1212.48 0, 1454.98 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.1420766836723 1562.7644898455842) rotate(0 727.4881099812983 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.98 0 L1441.38 6.34 L1441.38 -6.34 L1454.98 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.98 0 C1450.91 1.9, 1446.85 3.79, 1441.38 6.34 M1454.98 0 C1451.54 1.6, 1448.1 3.21, 1441.38 6.34 M1441.38 6.34 C1441.38 1.97, 1441.38 -2.4, 1441.38 -6.34 M1441.38 6.34 C1441.38 1.58, 1441.38 -3.19, 1441.38 -6.34 M1441.38 -6.34 C1445.49 -4.43, 1449.59 -2.51, 1454.98 0 M1441.38 -6.34 C1445 -4.65, 1448.62 -2.97, 1454.98 0 M1454.98 0 C1454.98 0, 1454.98 0, 1454.98 0 M1454.98 0 C1454.98 0, 1454.98 0, 1454.98 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-of34geQtwdWITT6ZL99ZE)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2005.1182966462684 1561.4393748911557) rotate(0 46.37902340500068 58.96761547207245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.46 10.6, 92.76 43.95, 92.76 63.61 C92.76 83.26, 15.46 108.88, 0 117.94 M0 0 C15.46 10.6, 92.76 43.95, 92.76 63.61 C92.76 83.26, 15.46 108.88, 0 117.94",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2005.1182966462684 1561.4393748911557) rotate(0 46.37902340500068 58.96761547207245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 117.94 L9.82 106.6 L15 118.17 L0 117.94",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 117.94 C3.09 114.37, 6.17 110.81, 9.82 106.6 M0 117.94 C3.37 114.04, 6.75 110.15, 9.82 106.6 M9.82 106.6 C11.4 110.12, 12.97 113.64, 15 118.17 M9.82 106.6 C11.19 109.66, 12.56 112.73, 15 118.17 M15 118.17 C11.8 118.12, 8.59 118.07, 0 117.94 M15 118.17 C10.67 118.1, 6.35 118.03, 0 117.94 M0 117.94 C0 117.94, 0 117.94, 0 117.94 M0 117.94 C0 117.94, 0 117.94, 0 117.94",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-of34geQtwdWITT6ZL99ZE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 2197.8763434562698,
    height: 1779.3746058353006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2022.5013434562698,
    y: 1612.5448927037282,
    fill: "#000",
    width: 150.75,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2022.5013434562698 1612.5448927037282) rotate(0 28.99597659499932 7.862097659499909)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 75.375,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Handle Members"))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-fHic4pJlrvqosDEYGtHyi)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2569.617267232852 697.4702129568466) rotate(0 -574.4373327447959 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-47.26 0, -92.1 0, -283.57 0 C-475.05 0, -1004.66 0, -1148.87 0 M0 0 C-47.26 0, -92.1 0, -283.57 0 C-475.05 0, -1004.66 0, -1148.87 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2569.617267232852 697.4702129568466) rotate(0 -574.4373327447959 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1148.87 0 L-1135.28 -6.34 L-1135.28 6.34 L-1148.87 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1148.87 0 C-1144.08 -2.24, -1139.28 -4.47, -1135.28 -6.34 M-1148.87 0 C-1145.99 -1.35, -1143.1 -2.69, -1135.28 -6.34 M-1135.28 -6.34 C-1135.28 -2.11, -1135.28 2.13, -1135.28 6.34 M-1135.28 -6.34 C-1135.28 -3.02, -1135.28 0.3, -1135.28 6.34 M-1135.28 6.34 C-1139.46 4.39, -1143.64 2.44, -1148.87 0 M-1135.28 6.34 C-1139.58 4.33, -1143.89 2.33, -1148.87 0 M-1148.87 0 C-1148.87 0, -1148.87 0, -1148.87 0 M-1148.87 0 C-1148.87 0, -1148.87 0, -1148.87 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-fHic4pJlrvqosDEYGtHyi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 3818.491932722444,
    height: 797.4702129568466
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2208.10100133572,
    y: 684.9702129568466,
    fill: "#000",
    width: 155.88333129882812,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2208.10100133572 684.9702129568466) rotate(0 -212.92106684766372 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 77.94166564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Projectile Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2580.2181868682806 686.5688335037037) rotate(0 109.98332977294922 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Store Projectile Data"))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5C-pG1pzbus1cpo8c-5fq)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2005.1182966462693 1708.5271348327296) rotate(0 -293.5129624059339 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-97.84 0, -489.19 0, -587.03 0 M0 0 C-97.84 0, -489.19 0, -587.03 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2005.1182966462693 1708.5271348327296) rotate(0 -293.5129624059339 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-587.03 0 L-573.43 -6.34 L-573.43 6.34 L-587.03 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-587.03 0 C-581.77 -2.45, -576.51 -4.9, -573.43 -6.34 M-587.03 0 C-583.12 -1.82, -579.22 -3.64, -573.43 -6.34 M-573.43 -6.34 C-573.43 -1.69, -573.43 2.96, -573.43 6.34 M-573.43 -6.34 C-573.43 -2.23, -573.43 1.87, -573.43 6.34 M-573.43 6.34 C-577.26 4.55, -581.09 2.77, -587.03 0 M-573.43 6.34 C-577.72 4.34, -582.02 2.34, -587.03 0 M-587.03 0 C-587.03 0, -587.03 0, -587.03 0 M-587.03 0 C-587.03 0, -587.03 0, -587.03 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5C-pG1pzbus1cpo8c-5fq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 2692.144221458137,
    height: 1808.5271348327296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1596.4219998897495,
    y: 1696.0271348327296,
    fill: "#000",
    width: 230.36666870117188,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1596.4219998897495 1696.0271348327296) rotate(0 115.18333435058594 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 115.18333435058594,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Squadron Member Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1612.6444980277925 1732.9801236478734) rotate(0 118.17500305175781 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Struct: Matrix, Velocity, etc..."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2207.5481786941878 719.2729718631333) rotate(0 142.10000610351562 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Struct: Matrix, Velocity, Valid, etc..."))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1453.8704756039747 89.49399299424971) rotate(0 97.5 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Buffers are synced "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "across compute shaders!"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1443.2695559685458 106.40332888744001) rotate(0 -28.489971520214795 44.70016013940582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-9.5 2.09, -49.25 -2.36, -56.98 12.54 C-64.71 27.44, -48.15 76.59, -46.38 89.4 M0 0 C-9.5 2.09, -49.25 -2.36, -56.98 12.54 C-64.71 27.44, -48.15 76.59, -46.38 89.4",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1443.2695559685458 106.40332888744001) rotate(0 -28.489971520214795 44.70016013940582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-46.38 89.4 L-55.64 77.6 L-43.29 74.72 L-46.38 89.4",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.38 89.4 C-49.39 85.56, -52.41 81.72, -55.64 77.6 M-46.38 89.4 C-48.61 86.56, -50.83 83.73, -55.64 77.6 M-55.64 77.6 C-52.13 76.78, -48.62 75.96, -43.29 74.72 M-55.64 77.6 C-53.11 77.01, -50.58 76.42, -43.29 74.72 M-43.29 74.72 C-44.36 79.82, -45.43 84.91, -46.38 89.4 M-43.29 74.72 C-44.45 80.24, -45.61 85.76, -46.38 89.4 M-46.38 89.4 C-46.38 89.4, -46.38 89.4, -46.38 89.4 M-46.38 89.4 C-46.38 89.4, -46.38 89.4, -46.38 89.4",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-OuBcjKschHWYvL6TSNO8b)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2003.7931816918444 1788.0340320984456) rotate(0 -293.51296240593365 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-97.84 0, -489.19 0, -587.03 0 M0 0 C-97.84 0, -489.19 0, -587.03 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2003.7931816918444 1788.0340320984456) rotate(0 -293.51296240593365 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-587.03 0 L-573.43 -6.34 L-573.43 6.34 L-587.03 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-587.03 0 C-582.11 -2.29, -577.19 -4.58, -573.43 -6.34 M-587.03 0 C-582.08 -2.3, -577.14 -4.61, -573.43 -6.34 M-573.43 -6.34 C-573.43 -3.42, -573.43 -0.49, -573.43 6.34 M-573.43 -6.34 C-573.43 -2.39, -573.43 1.56, -573.43 6.34 M-573.43 6.34 C-578.14 4.14, -582.86 1.94, -587.03 0 M-573.43 6.34 C-576.93 4.71, -580.43 3.07, -587.03 0 M-587.03 0 C-587.03 0, -587.03 0, -587.03 0 M-587.03 0 C-587.03 0, -587.03 0, -587.03 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-OuBcjKschHWYvL6TSNO8b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 2690.8191065037117,
    height: 1888.0340320984456
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1609.3385536364967,
    y: 1775.5340320984456,
    fill: "#000",
    width: 201.88333129882812,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1609.3385536364967 1775.5340320984456) rotate(0 100.94166564941406 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 100.94166564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "New Projectile Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2013.0689863728442 1680.6997207897293) rotate(0 98.13333129882812 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Store Member Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2017.0443312361301 1776.1079975085881) rotate(0 110.13333129882812 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Create new projectiles"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2051.497320051273 1807.7605265060174) rotate(0 175.48333740234375 40)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "\"Spawns\" new projectiles at the"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "last index, inherits member's transform"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "sets velocity, sets valid to true, increments"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 60,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "last index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.23724466523072 1056.0390813771853) rotate(0 113.94999694824219 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Dispatch Members Sort"))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-HDoCTaeye3Umlke9WR85v)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2571.0063300934617 772.6638608236146) rotate(0 -575 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-45.56 0, -81.67 0, -273.33 0 C-465 0, -1003.89 0, -1150 0 M0 0 C-45.56 0, -81.67 0, -273.33 0 C-465 0, -1003.89 0, -1150 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2571.0063300934617 772.6638608236146) rotate(0 -575 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1150 0 L-1136.41 -6.34 L-1136.41 6.34 L-1150 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1150 0 C-1146 -1.86, -1142 -3.73, -1136.41 -6.34 M-1150 0 C-1144.6 -2.52, -1139.19 -5.04, -1136.41 -6.34 M-1136.41 -6.34 C-1136.41 -3.4, -1136.41 -0.46, -1136.41 6.34 M-1136.41 -6.34 C-1136.41 -1.83, -1136.41 2.69, -1136.41 6.34 M-1136.41 6.34 C-1140.36 4.49, -1144.32 2.65, -1150 0 M-1136.41 6.34 C-1139.31 4.99, -1142.21 3.63, -1150 0 M-1150 0 C-1150 0, -1150 0, -1150 0 M-1150 0 C-1150 0, -1150 0, -1150 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-HDoCTaeye3Umlke9WR85v"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 3821.0063300934617,
    height: 872.6638608236146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2196.9979937083704,
    y: 760.1638608236146,
    fill: "#000",
    width: 201.35000610351562,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2196.9979937083704 760.1638608236146) rotate(0 -200.9916636149087 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 100.67500305175781,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Squad Member Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2578.3446972973106 760.5602126419469) rotate(0 106.64167022705078 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Update Member Data"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2796.647900820263 778.3656032948477) rotate(0 187.28334045410156 30.00000000000003)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Whilst updating projectiles, this is where we'll"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "know if a projectile killed a member, we need to"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "update that buffer if needed"))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.2920146170609 1068.5390813771853) rotate(0 1349.3559752781578 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C449.79 0, 2248.93 0, 2698.71 0 M0 0 C449.79 0, 2248.93 0, 2698.71 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.2920146170609 1068.5390813771853) rotate(0 1349.3559752781578 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2698.71 0 L2685.12 6.34 L2685.12 -6.34 L2698.71 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2698.71 0 C2695.26 1.61, 2691.81 3.22, 2685.12 6.34 M2698.71 0 C2695.81 1.35, 2692.91 2.7, 2685.12 6.34 M2685.12 6.34 C2685.12 2.96, 2685.12 -0.42, 2685.12 -6.34 M2685.12 6.34 C2685.12 1.27, 2685.12 -3.79, 2685.12 -6.34 M2685.12 -6.34 C2688.88 -4.58, 2692.64 -2.83, 2698.71 0 M2685.12 -6.34 C2688.43 -4.8, 2691.73 -3.25, 2698.71 0 M2698.71 0 C2698.71 0, 2698.71 0, 2698.71 0 M2698.71 0 C2698.71 0, 2698.71 0, 2698.71 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", null))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-vUP2qYJpbufhBbxIilSuv)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3247.8549386959485 1068.5294720176116) rotate(0 51.72210151864374 52.05365345145549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C17.24 8.29, 103.44 32.38, 103.44 49.73 C103.44 67.08, 17.24 95.04, 0 104.11 M0 0 C17.24 8.29, 103.44 32.38, 103.44 49.73 C103.44 67.08, 17.24 95.04, 0 104.11",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3247.8549386959485 1068.5294720176116) rotate(0 51.72210151864374 52.05365345145549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 104.11 L10.12 93.03 L14.99 104.74 L0 104.11",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 104.11 C3.39 100.39, 6.78 96.68, 10.12 93.03 M0 104.11 C3.09 100.72, 6.18 97.34, 10.12 93.03 M10.12 93.03 C11.31 95.91, 12.51 98.78, 14.99 104.74 M10.12 93.03 C11.76 96.99, 13.41 100.94, 14.99 104.74 M14.99 104.74 C10.11 104.53, 5.22 104.33, 0 104.11 M14.99 104.74 C9.94 104.53, 4.9 104.31, 0 104.11 M0 104.11 C0 104.11, 0 104.11, 0 104.11 M0 104.11 C0 104.11, 0 104.11, 0 104.11",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-vUP2qYJpbufhBbxIilSuv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 3451.299141733236,
    height: 1272.6367789205226
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3284.982476083822,
    y: 1105.7622619393844,
    fill: "#000",
    width: 132.63333129882812,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3284.982476083822 1105.7622619393844) rotate(0 14.594564130770323 14.820863529682697)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 66.31666564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Sort Members"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3399.042620058138 1131.5243392518573) rotate(0 163.21665954589844 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Just the same as we did with projectiles"))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0m4bh2ZVMrbRYa1q5UrjI)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3247.616673655251 1180.5954817052905) rotate(0 -916.6996860622498 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-71.44 0, -123.08 0, -428.65 0 C-734.22 0, -1599.27 0, -1833.4 0 M0 0 C-71.44 0, -123.08 0, -428.65 0 C-734.22 0, -1599.27 0, -1833.4 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3247.616673655251 1180.5954817052905) rotate(0 -916.6996860622498 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1833.4 0 L-1819.8 -6.34 L-1819.8 6.34 L-1833.4 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#343a40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1833.4 0 C-1828.63 -2.23, -1823.85 -4.45, -1819.8 -6.34 M-1833.4 0 C-1829.85 -1.65, -1826.3 -3.31, -1819.8 -6.34 M-1819.8 -6.34 C-1819.8 -3.49, -1819.8 -0.63, -1819.8 6.34 M-1819.8 -6.34 C-1819.8 -3.18, -1819.8 -0.02, -1819.8 6.34 M-1819.8 6.34 C-1824.86 3.98, -1829.92 1.62, -1833.4 0 M-1819.8 6.34 C-1822.67 5, -1825.54 3.67, -1833.4 0 M-1833.4 0 C-1833.4 0, -1833.4 0, -1833.4 0 M-1833.4 0 C-1833.4 0, -1833.4 0, -1833.4 0",
    stroke: "#343a40",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-0m4bh2ZVMrbRYa1q5UrjI"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 5181.01604577975,
    height: 1280.5954817052905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2724.02559263172,
    y: 1168.0954817052905,
    fill: "#000",
    width: 189.88333129882812,
    height: 25,
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2724.02559263172 1168.0954817052905) rotate(0 -393.1086050387189 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 94.94166564941406,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Last Member Index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3255.396892922348 1172.818163439223) rotate(0 102.11666870117188 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "Store the last index"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QiyQeUd1Rd70uVlKvTYhm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.2430910654566 1937.5622629751997) rotate(0 128.30833435058594 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "This is done for both projectiles"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "16px",
    fill: "#343a40",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "and members"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDiagram);
export default __webpack_public_path__ + "static/media/EventDiagram.9383ad9735005912782b354dc445c7a0.svg";
export { ForwardRef as ReactComponent };